module.exports = __webpack_public_path__ + "img/cotizar.60a4153c.png";